import React from 'react';
import { observer } from 'mobx-react-lite';
import { Typography } from '@mui/material';
import { Trans } from 'react-i18next';
import i18n from '../../i18n';
import { ReactComponent as CloudUploadIcon } from '../../static/images/svg/iconamoon_cloud-upload-fill.svg';
import type { MenuLibraryManagementState } from './menu-library-management-state';
import MenuLibraryFlowProgressDialog from './menu-library-flow-progress-dialog.component';
import MenuLibraryFlowResultDialog from './menu-library-flow-result-dialog.component';

/**
 * 上传至云端菜品库流程浮层：上传中 / 成功结果（Figma `9786:51121` 壳 + `9806:50724`）。
 */
const MenuLibraryUploadCloudFlowDialogs: React.FC<{ state: MenuLibraryManagementState }> = observer(
    ({ state }) => {
        const result = state.uploadToCloudResult;

        return (
            <>
                <MenuLibraryFlowProgressDialog
                    open={state.uploadToCloudSubmitting}
                    title={i18n.t('menu_library_upload_cloud_uploading_title')}
                    icon={<CloudUploadIcon />}
                />
                <MenuLibraryFlowResultDialog
                    open={result != null && !state.uploadToCloudSubmitting}
                    onClose={() => state.closeUploadToCloudResult()}
                    listVariant="chips"
                    chipItems={result?.items ?? []}
                    title={
                        <Trans
                            i18nKey="menu_library_upload_cloud_result_title"
                            values={{ menuCount: result?.menuCount ?? 0 }}
                            components={{
                                countHighlight: (
                                    <Typography
                                        component="span"
                                        variant="h3"
                                        className="menu-library-flow-result-dialog__count"
                                    />
                                ),
                            }}
                        />
                    }
                />
            </>
        );
    },
);

export default MenuLibraryUploadCloudFlowDialogs;
